import { useTranslation } from "react-i18next";

export const TermsAndConditionsCheckbox = (props) => {
  const { t } = useTranslation();
  const { isTermsChecked, setIsTermsChecked, setIsModalVisible } = props;
  return (
    <div className="form-check mt-3">
      <input
        className="form-check-input"
        type="checkbox"
        id="termsCheckbox"
        checked={isTermsChecked}
        onChange={(e) => setIsTermsChecked(e.target.checked)}
      />
      <label className="form-check-label" htmlFor="termsCheckbox">
        {t("booking.confirm_policy")}&nbsp;
        <span
          style={{
            textDecoration: "underline",
            color: "blue",
            cursor: "pointer",
          }}
          onClick={() => setIsModalVisible(true)}
        >
          {t("booking.term_conditions")}
        </span>
      </label>
    </div>
  );
};
